import Icon from "@mui/icons-material/AccountBalance";
import TallyConfigPage from "./TallyConfigPage";

export default {
  list: TallyConfigPage,
  icon: Icon,
  label: "Tally config",
  options: { label: "Tally config" },
  name: "tallyConfig",
};
